module.exports = __webpack_public_path__ + "static/media/source.05cbe287.gif";